var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1686 13.7656H15.364C16.1174 13.7656 16.7859 14.2477 17.0239 14.9626L17.6075 16.7126C17.9855 17.8457 17.142 19.0156 15.9476 19.0156H5.05387C3.85949 19.0156 3.01599 17.8457 3.39399 16.7126L3.97762 14.9626C4.21474 14.2477 4.88412 13.7656 5.63749 13.7656H7.83374",
    stroke: "#3158F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 16.3906C10.5 16.3906 5.25 12.1976 5.25 8.3695C5.25 5.55113 7.60025 3.26562 10.5 3.26562C13.3997 3.26562 15.75 5.55113 15.75 8.3695C15.75 12.1976 10.5 16.3906 10.5 16.3906ZM11.7374 7.27819C12.4209 7.96161 12.4209 9.06965 11.7374 9.75306C11.054 10.4365 9.94598 10.4365 9.26256 9.75306C8.57915 9.06965 8.57915 7.96161 9.26256 7.27819C9.94598 6.59477 11.054 6.59477 11.7374 7.27819Z",
    fill: "#3158F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.35bb2cfdb29cf7d5386330469d9a84ec.svg";
export { ForwardRef as ReactComponent };